// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"Ola-z"};